import type { ProgressionState } from "./progression";

export function clampHpToZero(hp: number): number {
  return Math.max(0, hp);
}

export function computeXpPenalty(state: ProgressionState): void {
  state.xp = 0;
}
